module.exports = __webpack_public_path__ + "img/1-37-1.1c5d3034.png";